import {
    LEVELADDITION_FETCHING,
    LEVELADDITION_FAILED,
    LEVELADDITION_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching:false,
    isError: false
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case LEVELADDITION_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false };
        case LEVELADDITION_FAILED:
            return { ...state, result: null, isFetching: false, isError: true };
        case LEVELADDITION_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false };
        default:
            return state;
    }
};
